// @ts-nocheck

import { FC, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { Variant } from '@rich-products-corp/react-ecomm-ui/dist/types/product/Variant';
import useSWR from 'swr';
import { useAsioProvider } from 'frontastic';
import Image from 'frontastic/lib/image';
import { useBlobStorage, useCart } from 'frontastic/provider';

const TinStepper = dynamic(
  () =>
    import('@rich-products-corp/cc-custom-components/dist/components/PageSections/marketing/hero-sections/TinStepper'),
  { ssr: true },
);

interface CustomTinProps {
  data: {
    data: {
      dataSource: {
        items: {
          variants: Variant[];
        };
      };
    };
  };
}

export const CustomTin: FC<CustomTinProps> = ({ data: componentData }) => {
  const router = useRouter();
  const asioProvider = useAsioProvider();

  const { data, error } = useSWR('merged-products', async () => {
    const result = await asioProvider.mergeProductVariantsIntoOneProduct();
    return result?.products ?? null;
  });

  const isLoading = !data && !error;

  const [variants, setVariants] = useState<Variant[]>();
  const tinSizes = componentData?.provinces?.dataSource?.value ?? undefined;

  useEffect(() => {
    if (data && !error) {
      const newVariants = data.variants.map((v: Variant) => {
        const images = v.images?.map((image) => image.url) ?? [];
        return { ...v, sku: v.sku ?? '', images };
      });
      setVariants(newVariants);
    }
  }, [data, error]);

  if (error) {
    console.error('provider.mergeProductVariantsIntoOneProduct error:', error);
    router.push('/custom-tin-loader');
    return <></>;
  }

  return (
    !isLoading && (
      <TinStepper
        variants={variants}
        useCart={useCart as any}
        useBlobStorage={useBlobStorage}
        Image={Image}
        tinSizes={tinSizes}
      />
    )
  );
};
